<template>
  <div id="app" ref="appRef">
    <nav class="navbar navbar-default" role="navigation" style="width: 100%;" v-if="$route.name != 'renew'">
      <div class="container-fluid">
        <div class="navbar-header flex align-center justify-between">
          <div class="box_headerL">
            <img src="./assets/images/logo.png" alt="" class="navbar-brand">
          </div>
          <button type="button" class="navbar-toggle" data-toggle="collapse"
                  data-target="#example-navbar-collapse" ref="toggle">
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>

        </div>
        <div class="collapse navbar-collapse" id="example-navbar-collapse">
          <div class="flex align-center justify-between">
            <div class="box_headerMR"></div>
            <div class="box_headerM nav navbar-nav flex align-center justify-center" >
              <div v-for="(item,index) in tabList" :key="index" class="tab_li"
                   :class="[activeMenu == item.url ? 'active_tab':'',hoverIndex == index ? 'hover_tab' : '']"
                   @click.stop="changeTab(item)" @mouseenter="mouseenter(index)" @mouseleave="mouseleave">
                <p>
                  <img :src="item.img" alt="" v-if="item.img" class="tab_img">
                  {{item.name}}
                  <span class="line" v-show="activeMenu == item.url"></span>
                </p>
              </div>
            </div>
            <div class="box_headerR hidden-xs">免费试用</div>
          </div>
        </div>
      </div>
    </nav>
    <router-view style="margin-top: 80px;width: 100%;"/>
    <div class="nav_footerBox " v-if="btnShow">
      <div class="nav_footer w_con" v-if="$route.name != 'renew'">
        <div class="footer_top flex align-center justify-start">
          <div class="footer_topL flex align-center justify-start">
            <img src="./assets/images/teams_logo.png" alt="">
            Teams
          </div>
          <div class="footer_topR">让天下没有难带的团队</div>
        </div>
        <div class="footer_btn flex align-center justify-start">
          <div class="footer_btnL">去使用Teams产品</div>
          <div class="footer_btnR">咨询</div>
        </div>
        <div class="footer_con flex align-start justify-between">
          <dl>
            <dt>热门链接</dt>
            <dd><a href="javascript:;">产品功能</a></dd>
            <dd><a href="javascript:;">价格与服务</a></dd>
            <dd><a href="javascript:;">关于我们</a></dd>
          </dl>
          <dl>
            <dt>帮助与支持</dt>
            <dd><a href="javascript:;">帮助中心</a></dd>
            <dd><a href="javascript:;">购买咨询</a></dd>
          </dl>
          <dl>
            <dt>探索OKR</dt>
            <dd><a href="javascript:;">客户案例</a></dd>
            <dd><a href="javascript:;">产品演示</a></dd>
          </dl>
          <dl>
            <dt>法律与法规</dt>
            <dd><a href="javascript:;">服务协议</a></dd>
            <dd><a href="javascript:;">隐私政策</a></dd>
          </dl>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
      btnShow:false,
      tabList:[
        {name:"首页",url:'/'},
        {name:"OKR",url:'/okr'},
        {name:"AMB",url:'/amb'},
        {name:"课程",url:'/course'},
        {name:"解决方案",url:'/scheme'},
        {name:"价格与服务",url:'/price'},
        {name:"我们的理念",url:'/idea',img:require('@/assets/images/my_idea.png')},
      ],
      hoverIndex:undefined,
    }
  },
  computed:{
    activeMenu() {
      const route = this.$route
      console.log("route",route)
      if (route.path) {
        return route.path
      }
    },
  },
  mounted() {
    setTimeout(()=>{
      this.btnShow = true
    },500)
  },
  methods:{
    // 点击tab
    changeTab(row){
      if(row && row.url){
        if(row.name == '价格与服务'){
          this.$router.push(row.url)
        }else{
          this.$router.push('/')
        }
        if(row.name == "OKR" || row.name == "AMB" || row.name == "解决方案"){
          this.$store.commit("SetTabIndex",0)
          let index = 1
          if(row.name == "AMB"){
            index = 2
          }else if(row.name == "解决方案"){
            index = 3
          }
          this.$store.commit("SetTabIndex",index)
          if(this.$refs.toggle){
            this.$refs.toggle.click()
          }
          return
        }else if(row.name == "首页"){
          window.scrollTo({
            top:0,
            behavior:"smooth"
          })
        }
        // this.$router.push(row.url)
        if(this.$refs.toggle){
          this.$refs.toggle.click()
        }
      }
    },
    mouseenter(index){
      this.hoverIndex = index
    },
    mouseleave(){
      this.hoverIndex = undefined
    }
  }
}
</script>

<style lang="less" scoped>
#app{
  width: 100%;
  height: 100%;
}
.navbar{
  height: 80px;
  margin-bottom: 0;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 102;
  background-color: transparent;
  backdrop-filter: blur(60px);
  .container-fluid{
    height: 100%;
  }
  .navbar-collapse{
    padding: 0;
  }
  .navbar-header{
    //height: 80px;
    height: 100%;
    &::before,&::after{
      display: none;
    }
  }
  .box_headerL{
    width: 120px;
    //height: 80px;
    //height: 100%;
    img{
      width: 100%;
      height: 100%;
    }
  }

  /* 大屏 */
  @media (min-width: 760px) {
    .navbar-collapse{
      height: 100% !important;
    }
    .box_headerM{
      width: 610px;
      height: 80px;
      z-index: 100;
      .tab_li{
        height: 100%;
        line-height: 80px;
        padding: 0 16px;
        cursor: pointer;
        user-select: none;
        p{
          position: relative;
          //height: 80px;
          font-weight: 400;
          font-size: 14px;
          //line-height: 16px;
          color: #4E5969;
          .line{
            position: absolute;
            bottom: 4px;
            left: 50%;
            transform: translateX(-50%);
            width: 100%;
            height: 4px;
            background-color: #165DFF;
            border-radius: 10px;
          }
          .tab_img{
            width: 16px;
            height: 16px;
          }
          //padding-bottom: 24px;
          //border-bottom: 4px solid #165DFF;
        }
      }
      .active_tab{
        p{
          font-weight: 700;
          color: #1D2129;
        }
      }
      .hover_tab{
        background: linear-gradient(0deg, rgba(236, 241, 255, 0) 0%, #ECF1FF 52.08%, rgba(236, 241, 255, 0) 100%);
      }
    }
  }
  /* 小屏幕（平板，大于等于 768px） */
  @media (max-width: 760px) {
    .navbar-collapse{
      padding: 0;
      //height: auto !important;
    }
    .box_headerM{
      flex-direction: column;
      width: 100%;
      margin: 0;
      z-index: 100;
      align-items: flex-start;
      //background-color: pink;
      background-color: #f8f8f8;
      color: #777;
      .tab_li{
        width: 100%;
        margin: 0;
        padding: 0 20px;
        line-height: 40px;
        cursor: pointer;
        p{
          margin-bottom: 0;
        }
        &:hover{
          background-color: #e7e7e7;
          color: #555;
        }
      }
    }
  }
  .box_headerR{
    width: 88px;
    height: 32px;
    background: #165DFF;
    border-radius: 3px;
    font-weight: 400;
    font-size: 14px;
    line-height: 32px;
    text-align: center;
    color: #FFFFFF;
    cursor: pointer;
    flex-shrink: 0;
    cursor: pointer;
  }
}
.w_con{
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
}
.nav_footerBox{
  background: linear-gradient(276.16deg, #317FDB 1.06%, #B4D2FF 90.12%);
}
.nav_footer{
  width: 100%;
  height: 800px;
  padding: 160px 11% 0;
  //background: linear-gradient(276.16deg, #317FDB 1.06%, #B4D2FF 90.12%);
  .footer_top{
    height: 62px;
    margin-bottom: 40px;
    padding: 0 14px;
    .footer_topL{
      font-weight: 400;
      font-size: 28px;
      line-height: 35px;
      color: #FFFFFF;
        img{
          width: 48px;
          height: 48px;
          margin-right: 20px;
        }
    }
    .footer_topR{
      margin-left: 34px;
      font-weight: 700;
      font-size: 20px;
      line-height: 23px;
      color: #fff;
    }
  }
  .footer_btn{
    height: 44px;
    margin-bottom: 150px;
    .footer_btnL{
      width: 163px;
      height: 44px;
      line-height: 44px;
      text-align: center;
      border-radius: 8px;
      background: #FFFFFF;
      font-weight: 500;
      font-size: 14px;
      color: #1D2129;
      cursor: pointer;
    }
    .footer_btnR{
      width: 76px;
      height: 44px;
      line-height: 44px;
      text-align: center;
      border: 1px solid #FFFFFF;
      border-radius: 8px;
      font-weight: 500;
      font-size: 14px;
      color: #FFFFFF;
      margin-left: 16px;
      cursor: pointer;
    }
  }
  .footer_con{
    width: 50%;
    dl{
      color: #FFFFFF;
      dt{
        font-weight: 600;
        font-size: 20px;
        line-height: 28px;
        margin-bottom: 30px;
      }
      dd{
        margin-bottom: 16px;
        line-height: 20px;
        &:last-child{
          margin-bottom: 0;
        }
        a{
          font-weight: 400;
          font-size: 14px;
          color: #fff;
        }
      }
    }
  }
}
@media (max-width: 760px) {
  .navbar{
    height: 38px;
  }
  .tab_img{
    display: none;
  }
  .box_headerL{
    width: 90px !important;
    img{
      padding: 0 !important;
    }
  }
  .nav_footer{
    height: 370px;
    padding: 74px 0 0 74px;
    .footer_top{
      height: 28px;
      margin-bottom: 18px;
      padding: 0 6px;
      .footer_topL{
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;
        color: #FFFFFF;
        img{
          width: 22px;
          height: 22px;
          margin-right: 10px;
        }
      }
      .footer_topR{
        margin-left: 16px;
        font-weight: 700;
        font-size: 15px;
        line-height: 10px;
        color: #fff;
      }
    }
    .footer_btn{
      height: 20px;
      margin-bottom: 70px;
      .footer_btnL{
        width: 163px;
        height: 44px;
        line-height: 44px;
        text-align: center;
        border-radius: 8px;
        background: #FFFFFF;
        font-weight: 500;
        font-size: 14px;
        color: #1D2129;
        cursor: pointer;
        transform: translateX(-20%) scale(0.5);
      }
      .footer_btnR{
        width: 76px;
        height: 44px;
        line-height: 44px;
        text-align: center;
        border: 1px solid #FFFFFF;
        border-radius: 8px;
        font-weight: 500;
        font-size: 14px;
        color: #FFFFFF;
        margin-left: 16px;
        cursor: pointer;
        transform: translateX(-100%-30px) scale(0.5);
      }
    }
    .footer_con{
      //width: 50%;
      width: 85%;
      //transform:translateX(-25%) ;
      dl{
        color: #FFFFFF;
        dt{
          font-weight: 600;
          font-size: 10px;
          line-height: 28px;
          margin-bottom: 14px;
        }
        dd{
          line-height: 20px;
          margin-bottom: 7px;
          &:last-child{
            margin-bottom: 0;
          }
          a{
            font-weight: 400;
            font-size: 8px;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue